import { render, staticRenderFns } from "./exponencial.vue?vue&type=template&id=d66ce92a&"
import script from "./exponencial.vue?vue&type=script&lang=js&"
export * from "./exponencial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports